<template>
  <section class="top-banner">
    <!--    left side-->
    <div class="w-full lg:w-auto">
      <!--      title-->
      <SectionBannerTitle
        :title-class="titleClass"
        :title="title"
        :subtitle="subtitle"
        :img-type="titleImgType"
      />
      <!--      input search-->
      <div v-if="$slots.action" class="mt-12">
        <client-only>
          <slot name="action" />
        </client-only>
      </div>
      <!--      navigations: [IELTS, TOEFL SPEAKING BUSINESS]-->
      <!--  <SectionBannerNavigations :navigations="navigations" /> -->
      <div />
    </div>
    <!--    right side-->
    <SectionBannerSvgContainer
      :img="img"
      :has-background="hasBackground"
      :img-sizes="imgSizes"
    />
  </section>
</template>

<script>
import SectionBannerTitle from './top-banner-title.vue'
// import SectionBannerNavigations from '~/components/pages/home/top-banner/top-banner-navigations.vue'
import SectionBannerSvgContainer from './top-banner-svg-container.vue'

export default {
  name: 'SectionTopBanner',
  components: {
    SectionBannerTitle,
    // SectionBannerNavigations,
    SectionBannerSvgContainer
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: 'max-w-full lg:max-w-[512px]'
    },
    subtitle: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    titleImgType: {
      type: String,
      default: 'home'
    },
    imgSizes: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hasBackground: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.top-banner {
  @apply container flex flex-col-reverse lg:flex-row
  items-center justify-between;
}
</style>
